import { API_URL } from './Constants';
import ApiService from './ApiService';
import { EditorState } from 'draft-js';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class TintucPageApi {

    static getListByCat = async (catId) => {
        try {
            let params = {};
            if (catId !== null) {
                params = { catId };
            }
            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/list-by-cat", params);
        } catch (error) {
        }
    };

    static getChiTietTintuc = async (postId) => {
        try {
            let params = {};
            if (postId !== null) {
                params = { postId };
            }

            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/chi-tiet", params);
        } catch (error) {
        }
    };

    static getAllData = async () => {
        try {
            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/all-data");
        } catch (error) {
        }
    };

    static getAllType = async (postType) => {
        try {
            let params = {};
            if (postType !== null) {
                params = { postType };
            }
            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/all-type", params);
        } catch (error) {
        }
    };

    // --------------- ADMIN -----------------
    static submitPost = async (formData) => {
        console.log("Data: ", formData)

        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        // Removed duplicate content append here
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("type", formData.postType);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if(formData.content) {
            const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
            const htmlContent = draftToHtml(rawContent);  // Convert to HTML
            data.append("content", htmlContent); // Assuming it's a string
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/tin-tuc/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        console.log("Data: ", formData)

        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        // Removed duplicate content append here
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile);
        data.append("type", formData.postType);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }

        if(formData.content) {
            const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
            const htmlContent = draftToHtml(rawContent);  // Convert to HTML
            data.append("content", htmlContent); // Assuming it's a string
        }

        if (formData.image) {
            data.append("image", formData.image); // Add image if available
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/tin-tuc/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietTintucAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/detail", params);
        } catch (error) {
        }
    };
}

export default TintucPageApi;